import { Skeleton } from '@/components/ui/Skeleton';
import { cn } from '@/lib/utils';

export interface ConferenciaFinalSkeletonProps {
  /** Quantidade de saídas desenhadas. Default 2. */
  saidas?: number;
  className?: string;
  /** O anúncio do carregamento para o leitor de tela. */
  label?: string;
}

/** E200.F3 (GUS-220): a conferência final enquanto o servidor responde — versão, saídas, confirmação. */
export function ConferenciaFinalSkeleton({
  saidas = 2,
  className,
  label,
}: ConferenciaFinalSkeletonProps) {
  return (
    <div
      data-testid="conferencia-final-skeleton"
      role="status"
      aria-label={label}
      className={cn('flex flex-col gap-sc-4', className)}
    >
      <Skeleton className="h-4 w-72" data-testid="conferencia-final-skeleton-versao" />
      <div className="flex flex-col gap-2 border border-border p-sc-4">
        <Skeleton className="h-5 w-48" />
        {Array.from({ length: saidas }).map((_, i) => (
          <Skeleton
            key={i}
            className="h-12 w-full"
            data-testid="conferencia-final-skeleton-saida"
          />
        ))}
      </div>
      <Skeleton className="h-9 w-56" data-testid="conferencia-final-skeleton-confirmar" />
    </div>
  );
}
